import React from 'react';

import Header from '../../Components/Header';
import Footer from '../../Components/Footer';
import classes from './styles.module.css';

export default function PublicLayout({ children, footerProps, menuConfig }) {
    return (
        <div className={classes.Wrapper}>
            <Header menuConfig={menuConfig} showMenu={false} />
            <div className={`${classes.Content} ${classes.PublicContent}`}>{children}</div>
            <Footer {...footerProps} />
        </div>
    );
}



// WEBPACK FOOTER //
// ./src/hoc/Layout/PublicLayout.js